import React, { useContext, useEffect, useState } from 'react';
import { Layout, Menu, Table, Space, Image, Tag, Button, Form, Input, Typography } from 'antd';
import { DeleteTwoTone, EditTwoTone, PlusOutlined, AudioOutlined } from '@ant-design/icons'
import { Link, useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import './Admin.css'
import axios from 'axios';
import { UserContext } from '../UserContext';

const { Content, Sider } = Layout;
const { Title } = Typography;
const { Search } = Input;


// data api
const MOVIE_API = "https://backendexample.sanbersy.com/api/data-movie"
const GAME_API = "https://backendexample.sanbersy.com/api/data-game"

const Admin = () => {
  
  let history = useHistory()
  const {user, isMovie, setIsMovie} = useContext(UserContext)
  const [items, setItems] = useState([])
  const [trigger, setTrigger] = useState(true)
  const [api, setApi] = useState(MOVIE_API)
  const [form, setForm] = useState(false)
  const [input, setInput] = useState({
    currentPassword : "",
    newPassword : "",
    confirmPassword : "",
  })
  const [temp, setTemp] = useState([])

  useEffect(() => {
    if (trigger) {
      if (isMovie) {
        const getData = async () => {
          const result = await axios.get(MOVIE_API)
          setItems([...result.data])
          setTrigger(false)
        }
        getData()
      } else {
        const getData = async () => {
          const result = await axios.get(GAME_API)
          setItems([...result.data])
          setTrigger(false)
        }
        getData()
      }
    }
  }, [trigger])

  const changeData = (api) => {
    if (api === 'password') {
      setForm(true)
    } else {
      setForm(false)
      // setApi(api)
      
      if (api === MOVIE_API) {
        setIsMovie(true)
      } else {
        setIsMovie(false)
      }

      setTrigger(true)
    }
  }

  const onDelete = (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this item!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        axios.delete(api + '/' + id, {headers: {"Authorization" : "Bearer "+ user.token}})
          .then(() => {
            swal(`Success delete this ${api === MOVIE_API ? 'movie' : 'game'}`, {
              icon: "success",
            });
            setTrigger(true)
          }).catch(err => {
            swal(`Failed to delete this ${api === MOVIE_API ? 'movie' : 'game'} because ${JSON.stringify(err.response.data)}`, {
              icon: "error",
            });
          })
      } else {
        swal(`Your ${api === MOVIE_API ? 'movie' : 'game'} is safe!`,{
          icon: "success",
        });
      }
    });
  }

  const onChange = (e) => {
    const name = e.target.name
    const value = e.target.value
    
    setInput({
      ...input,
      [name] : value
    })
  }

  const onSubmit = () => {
    const currPass = input.currentPassword
    const newPass = input.newPassword
    const newConfPass = input.confirmPassword

    swal({
      title: "Are you sure?",
      text: "Soon, you not to able use this current password",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willChange) => {
      if (willChange) {
        axios.post("https://backendexample.sanbersy.com/api/change-password", {
          current_password: currPass,
          new_password: newPass,
          new_confirm_password: newConfPass,
        }, {headers: {"Authorization" : "Bearer "+ user.token}})
          .then(res => {
            setInput({
              currentPassword : "",
              newPassword : "",
              confirmPassword : "",
            })
            console.log(res)
            swal("Congratulation!", "Your password has changed!", {
              icon: "success",
            });
          })
          .catch(err => {
            swal(`Failed to change password because ${JSON.stringify(err.response.data)}`, {
              icon: "error",
            });
            console.log('gagal')
            console.log(err.response.data)
          })
        
      } else {
        console.log('Canceled')
      }
    });
  }

  const onEdit = (id) => {
    history.push('/edit/'+id)
  }

  const fill = []
  for(let i = 1; i <= 10; i++){
    fill.push({ text: `${i}/10`, value: `${i}/10` })
  }

  const columnMovie = [
    {
      title: "No",
      dataIndex: "key",
      key: "index",
      sorter: (a, b) => a.key - b.key
    },
    {
      title: "Poster",
      dataIndex: "image_url",
      key: "image_url",
      sorter: (a, b) => a.image_url.length - b.image_url.length,
      render: (text,) => (
        <Image
          width={100}
          src={text}
        />
      )
    },
    {
      title: "Movies",
      dataIndex : "title",
      key : "title",
      sorter: (a, b) => a.title.length - b.title.length,
    },
    {
      title: "Genre",
      dataIndex: "genre",
      key: "genre",
      sorter: (a, b) => a.genre.length - b.genre.length,
    },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating",
      filters: fill,
      sorter: (a, b) => parseInt(a.rating) - parseInt(b.rating),
      onFilter : (val, rec) => rec.rating === val
    },
    {
      title: "Duration (min)",
      dataIndex: "duration",
      key: "duration",
      filters: [
        {
          text: "< 120",
          value: true
        },
        {
          text: "> 120",
          value: false
        }
      ],
      sorter: (a, b) => a.duration - b.duration,
      onFilter: (value, record) => {
        if (value) {
          return record.duration <= 120
        } else {
          return record.duration >= 120
        }
      },
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      filters: [
        {
          text: "< 2010",
          value: true
        },
        {
          text: "> 2010",
          value: false
        }
      ],
      sorter: (a, b) => a.year - b.year,
      onFilter: (value, record) => {
        if (value) {
          return record.year <= 2010
        } else {
          return record.year >= 2010
        }
      },
    },
    {
      title: "Action",
      key: "action",
      dataIndex: "id",
      render: (text) => (
        <Space size="middle">
          <EditTwoTone onClick={() => {onEdit(text)}} />
          <DeleteTwoTone twoToneColor="#db3737" onClick={() => {onDelete(text)}} />
        </Space>
      ),
    },
  ];

  let dataMovies = items.map((e, index) => ({
    key: index+1,
    id: e.id,
    image_url : e.image_url,
    title: e.title,
    genre: e.genre,
    rating: `${e.rating}/10`,
    duration: e.duration,
    year: e.year
  }))
  
  const columnGame = [
    {
      title: "No",
      dataIndex: "key",
      key: "index",
      sorter: (a, b) => a.key - b.key,
    },
    {
      title: "Poster",
      dataIndex: "image_url",
      key: "image_url",
      render: (text) => (
        <Image
          width={100}
          src={text}
        />
      )
    },
    {
      title: "Games",
      dataIndex : "name",
      key : "name",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Genre",
      dataIndex: "genre",
      key: "genre",
      sorter: (a, b) => a.genre.length - b.genre.length,
    },
    {
      title: "Single Player",
      dataIndex: "singlePlayer",
      key: "singlePlayer",
      filters: [
        {
          text: "YES",
          value: 1
        },
        {
          text: "NO",
          value: 0
        },
      ],
      sorter: (a, b) => a.singlePlayer.length - b.singlePlayer.length,
      onFilter: (value, record) => record.singlePlayer === value,
      render: text => (
        <>
          {
            text === 0 ?  
            <Tag color={'volcano'} key='singlePlayer'>
              NO
            </Tag>
            : <Tag color={'green'} key='singlePlayer'>
                YES
              </Tag>
          }
        </>
      ),
      sortDirections: ['descend'],
    },
    {
      title: "Multi Player",
      dataIndex: "multiplayer",
      key: "multiplayer",
      filters : [
        {
          text: "YES",
          value: 1
        },
        {
          text: "NO",
          value: 0
        },

      ],
      sorter: (a, b) => a.multiplayer.length - b.multiplayer.length,
      onFilter: (value, record) => record.multiplayer === value,
      render: text => (
        <>
          {
            text === 0 ?  
            <Tag color={'volcano'} key='multiplayer'>
              NO
            </Tag>
            : <Tag color={'green'} key='multiplayer'>
                YES
              </Tag>
          }
        </>
      ),
    },
    {
      title: "Platform",
      dataIndex: "platform",
      key: "platform",
      sorter: (a, b) => a.platform.length - b.platform.length,
    },
    {
      title: "Year Release",
      dataIndex: "release",
      key: "release",
      filters: [
        {
          text: "< 2010",
          value: true
        },
        {
          text: "> 2010",
          value: false
        }
      ],
      sorter: (a, b) => a.release - b.release,
      onFilter: (value, record) => {
        if (value) {
          return record.release <= 2010
        } else {
          return record.release >= 2010
        }
      },
    },
    {
      title: "Action",
      key: "action",
      dataIndex: "id",
      render: (text) => (
        <Space size="middle">
          <EditTwoTone onClick={() => {onEdit(text)}} />
          <DeleteTwoTone twoToneColor="#db3737" onClick={() => {onDelete(text)}} />
        </Space>
      ),
    },
  ];
  
  let dataGames = items.map((e, index) => ({
    key: index+1,
    id: e.id,
    image_url : e.image_url,
    name: e.name,
    genre: e.genre,
    singlePlayer: e.singlePlayer,
    multiplayer: e.multiplayer,
    platform: e.platform,
    release: e.release,
  }))

  const onSearch = value => {
    if (isMovie) {
      const res = items.filter((e) => e.title === value)
      if (res.length > 0) {
        setItems(res)
      } else {
        swal({
          title: "Movie not found",
          text: "Input movie title completely!",
          icon: "error",
        });
        setTrigger(true)
      }
    } else {
      const res = items.filter((e) => e.name === value)
      if (res.length > 0) {
        setItems(res)
      } else {
        swal({
          title: "Game not found",
          text: "Input game name completely!",
          icon: "error",
        });
        setTrigger(true)
      }
    }
  }

  return (
    <>
      <div id="admin-page">
        <Layout>
          <Sider width={200} className="site-layout-background">
            <Menu
              mode="inline"
              // defaultSelectedKeys={['1']}
              onClick={(e) => {changeData(e.key)}}
              defaultSelectedKeys={isMovie ? MOVIE_API : GAME_API}
              style={{ height: '100%', borderRight: 0 }}
            >
              <Menu.Item title="movies" key={MOVIE_API}>Movies</Menu.Item>
              <Menu.Item title="games" key={GAME_API}>Games</Menu.Item>
              <Menu.Item title="games" key="password">Change Password</Menu.Item>
            </Menu>
          </Sider>
          <Layout style={{ padding: '0 24px 24px' }}>
            <Content
              className="site-layout-background"
              style={{
                padding: 24,
                margin: 0,
                minHeight: 280,
              }}
            >
              <div id="admin">
                {
                  !form ? 
                  <>
                    <Title level={2}> {isMovie ? "Movies List" : "Games List"} </Title>
                    <div className="func">
                      <Link to="/create">
                        <Button type="primary"><PlusOutlined /> Add {isMovie ? "Movie" : "Games"}</Button>
                      </Link>
                      <Search 
                        placeholder={`find ${isMovie ? 'movie' : 'game'} by ${isMovie ? 'title' : 'name'}`}
                        onSearch={onSearch}
                        // onChange={onChangeSearch}
                        enterButton 
                      />
                    </div>
                    <Table 
                      columns={isMovie ? columnMovie : columnGame}
                      dataSource={isMovie ? dataMovies : dataGames}
                    />
                  </>
                  :  <Form
                      name="basic"
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 6 }}
                      onFinish={onSubmit}
                      initialValues=""
                    >
                      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Title level={2}>
                          Reset Password
                        </Title>
                      </Form.Item>
                      <Form.Item
                        label="Current Password"
                        name="currentPassword"
                        rules={[{ required: true, message: 'Please input your current password!' }]}
                      >
                        <Input.Password name="currentPassword" onChange={onChange} />
                      </Form.Item>
                      <Form.Item
                        label="New Password"
                        name="newPassword"
                        rules={[{ required: true, message: 'Please input your new password!' }]}
                      >
                        <Input.Password name="newPassword" onChange={onChange} />
                      </Form.Item>
                      <Form.Item
                        label="Confirm Your Password"
                        name="confirmPassword"
                        rules={[{ required: true, message: 'Please confirm your new password!' }]}
                        hasFeedback 
                        validateStatus={input.newPassword === input.confirmPassword ? "" : "error"}
                        help={input.newPassword === input.confirmPassword ? "" : "Password doesn't match with new password"}
                        
                      >
                        <Input.Password name="confirmPassword" onChange={onChange} />
                      </Form.Item>

                      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Button type="primary" htmlType="submit">
                          Submit
                        </Button>
                      </Form.Item>
                    </Form>
                }

              </div>
            </Content>
          </Layout>
        </Layout>
      </div>
    </>
  )
}

export default Admin